export const TRACKING_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_id',
  'utm_name',
  'utm_share',
  'gclid',
  'gclsrc',
  'dclid',
  'fbclid',
  'msclkid',
  'twclid',
  'ttclid',
  'igshid',
  'li_fat_id',
  'epik',
  'sc_click_id',
  'mc_cid',
  'mc_eid',
  '_hsenc',
  '_hsmi',
  'vero_id',
  'vero_conv',
  'oly_enc_id',
  'oly_anon_id',
  'mkt_tok',
  'trk',
  'trkcampaign',
  '_ga',
  '_gl',
  'yclid',
  'rb_clickid',
  'ref_',
] as const

const TRACKING_PARAM_SET = new Set<string>(TRACKING_PARAMS)

/** Removes only known marketing parameters while preserving functional URL state. */
export function removeKnownTrackingParameters(value: string, removeHash = false): string {
  try {
    const parsed = new URL(value)
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return value
    let changed = false
    for (const key of [...parsed.searchParams.keys()]) {
      if (TRACKING_PARAM_SET.has(key.toLowerCase())) {
        parsed.searchParams.delete(key)
        changed = true
      }
    }
    if (removeHash && parsed.hash) {
      parsed.hash = ''
      changed = true
    }
    return changed ? parsed.toString() : value
  } catch {
    return value
  }
}
